import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { AR_TEXT } from "./arText";

export const STRINGS = {
  en: {
    save_contact: "Save Contact", show_qr: "Show QR", add_wallet: "Add to Apple Wallet",
    wallet_ios_only: "Apple Wallet works on iPhone. Open this page on your iPhone to add your card.",
    phone: "Phone", whatsapp: "WhatsApp", email: "Email", website: "Website", linkedin: "LinkedIn",
    twitter: "X", instagram: "Instagram", copy_link: "Copy link", copied: "Link copied",
    download_qr: "Download PNG", scan_to_open: "Scan to open this card",
    inactive_title: "This card is no longer active",
    inactive_body: "The person you're looking for is no longer using this digital card.",
    not_found_title: "Card not found", not_found_body: "This link doesn't match any card.",
    visit_website: "Visit company website", sign_in: "Sign in with Google",
    sign_in_title: "Your digital business card",
    sign_in_body: "Sign in with your company Google Workspace account to manage your card.",
    google_not_configured: "Google sign-in isn't configured yet. An administrator needs to add the OAuth client.",
    my_card: "My card", sign_out: "Sign out",
    edit_details: "Your details", edit_hint: "Name, title and email are managed by your administrator.",
    photo: "Photo", upload_photo: "Upload photo", remove_photo: "Remove",
    save_changes: "Save changes", saved: "Card updated", share: "Share your card", open_card: "Open public card",
    no_card_title: "No card yet", no_card_body: "Your account doesn't have a card yet. Add yourself from the Employees page.",
    card_colour: "Card colour", card_colour_hint: "Pick from the Inception palette.", admin_managed: "Managed by admin",
    about: "About", admin: "Settings",
    insights: "Insights", ins_views: "Card views", ins_qr: "QR scans", ins_visitors: "Unique visitors",
    ins_saves: "Contacts saved", ins_save_rate: "Save rate", ins_wallet: "Wallet downloads", ins_clicks: "Link taps",
    ins_daily: "Daily views", ins_link_views: "Opened by link", ins_top_links: "Most tapped", ins_devices: "Devices",
    ins_mobile: "Mobile", ins_desktop: "Desktop", ins_days: "days", ins_none: "No taps yet.",
    ins_empty: "No activity yet. Share your card link or QR code to start seeing insights.",
    ins_note: "Counts are anonymous. Your own visits to your card are not counted.",
    wallet_title: "Apple Wallet", wallet_once: "Add your card to Apple Wallet. You can download your pass once.",
    wallet_added: "Added to Wallet on", wallet_reset_hint: "Need it again (new phone or new title)? Ask an admin to allow a new download.",
  },
  ar: {
    save_contact: "حفظ جهة الاتصال", show_qr: "عرض رمز QR", add_wallet: "إضافة إلى Apple Wallet",
    wallet_ios_only: "تعمل Apple Wallet على iPhone. افتح هذه الصفحة من جوالك iPhone لإضافة بطاقتك.",
    phone: "الهاتف", whatsapp: "واتساب", email: "البريد الإلكتروني", website: "الموقع", linkedin: "لينكدإن",
    twitter: "إكس", instagram: "إنستغرام", copy_link: "نسخ الرابط", copied: "تم نسخ الرابط",
    download_qr: "تنزيل PNG", scan_to_open: "امسح الرمز لفتح البطاقة",
    inactive_title: "هذه البطاقة لم تعد فعّالة",
    inactive_body: "الشخص الذي تبحث عنه لم يعد يستخدم هذه البطاقة الرقمية.",
    not_found_title: "البطاقة غير موجودة", not_found_body: "هذا الرابط لا يطابق أي بطاقة.",
    visit_website: "زيارة موقع الشركة", sign_in: "تسجيل الدخول عبر Google",
    sign_in_title: "بطاقة عملك الرقمية",
    sign_in_body: "سجّل الدخول بحساب Google Workspace الخاص بالشركة لإدارة بطاقتك.",
    google_not_configured: "لم يتم إعداد تسجيل الدخول عبر Google بعد.",
    my_card: "بطاقتي", sign_out: "تسجيل الخروج",
    edit_details: "بياناتك", edit_hint: "الاسم والمسمى والبريد يديرها المسؤول.",
    photo: "الصورة", upload_photo: "رفع صورة", remove_photo: "إزالة",
    save_changes: "حفظ التغييرات", saved: "تم تحديث البطاقة", share: "شارك بطاقتك", open_card: "فتح البطاقة العامة",
    no_card_title: "لا توجد بطاقة", no_card_body: "لا توجد بطاقة لحسابك بعد. أضف نفسك من صفحة الموظفين.",
    card_colour: "لون البطاقة", card_colour_hint: "اختر من ألوان هوية Inception.", admin_managed: "يديره المسؤول",
    about: "نبذة", admin: "الإعدادات",
    insights: "الإحصائيات", ins_views: "مشاهدات البطاقة", ins_qr: "مسح رمز QR", ins_visitors: "زوار فريدون",
    ins_saves: "حفظ جهة الاتصال", ins_save_rate: "نسبة الحفظ", ins_wallet: "تنزيلات Wallet", ins_clicks: "النقر على الروابط",
    ins_daily: "المشاهدات اليومية", ins_link_views: "فُتحت عبر الرابط", ins_top_links: "الأكثر نقراً", ins_devices: "الأجهزة",
    ins_mobile: "جوال", ins_desktop: "كمبيوتر", ins_days: "يوم", ins_none: "لا توجد نقرات بعد.",
    ins_empty: "لا يوجد نشاط بعد. شارك رابط بطاقتك أو رمز QR لتبدأ الإحصائيات.",
    ins_note: "الأرقام مجهولة الهوية. زياراتك لبطاقتك لا تُحتسب.",
    wallet_title: "Apple Wallet", wallet_once: "أضف بطاقتك إلى Apple Wallet. يمكنك تنزيلها مرة واحدة فقط.",
    wallet_added: "أُضيفت إلى Wallet في", wallet_reset_hint: "تحتاجها مرة أخرى (جوال جديد أو مسمى جديد)؟ اطلب من المسؤول السماح بتنزيل جديد.",
  },
};

export const ALL_TEXT_KEYS = [...Object.keys(STRINGS.en), ...Object.keys(AR_TEXT)];
export const defaultText = (lang, key) =>
  (lang === "ar" ? STRINGS.ar[key] || AR_TEXT[key] : STRINGS.en[key] || (key in AR_TEXT ? key : "")) || "";

const fill = (text, vars) => (vars ? text.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m)) : text);

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("dbc_lang") || "en");
  const [overrides, setOverrides] = useState({ en: {}, ar: {} });
  useEffect(() => { api.get("/public/translations").then(({ data }) => setOverrides(data)).catch(() => {}); }, []);
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("dbc_lang", lang);
  }, [lang]);
  const t = useCallback((key, vars) => fill(
    overrides[lang]?.[key] || defaultText(lang, key) || overrides.en?.[key] || defaultText("en", key) || key, vars),
  [lang, overrides]);
  const pick = useCallback((en, ar) => (lang === "ar" && ar ? ar : en), [lang]);
  const setLang = useCallback((next) => {
    setLangState(next);
    api.put("/me/lang", { lang: next }).catch(() => {});
  }, []);
  return <LangContext.Provider value={{ lang, setLang, t, pick, overrides, setOverrides }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
